import { render, staticRenderFns } from "./LabelDetail.vue?vue&type=template&id=a272b09a&scoped=true"
import script from "./LabelDetail.vue?vue&type=script&lang=js"
export * from "./LabelDetail.vue?vue&type=script&lang=js"
import style0 from "./LabelDetail.vue?vue&type=style&index=0&id=a272b09a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a272b09a",
  null
  
)

export default component.exports